import { PositionService } from './position-service';

class DropdownServiceClass {
  constructor() {
    this.tooltipZIndex = 100;
  }

  getStyleForPositionAndBoundingBox(position, boundingBox, dropdownMenuShouldHaveWidthOfButton) {
    const style = PositionService.getStyleFromBoundingBox(position, boundingBox, this.getValidPositions());
    if (dropdownMenuShouldHaveWidthOfButton) {
      style.width = boundingBox.width;
    }
    return style;
  }

  getValidPositions() {
    return ['bottom-left', 'top-left', 'top-right', 'bottom-right'];
  }

  getNextPosition(currentPosition) {
    return PositionService.getNextPosition(currentPosition, this.getValidPositions());
  }
}

export const DropdownService = new DropdownServiceClass();
